module.exports = __webpack_public_path__ + "img/fundo.486277d2.svg";